<app-header></app-header>

<div class="m-10 h-full">
    <router-outlet />
</div>